module.exports = __webpack_public_path__ + "static/assets/8aa016b0e6209468cbe425d5f599dabc.svg";